import React, { useCallback, useEffect, useRef } from "react";
import CorporateSignupForm from "./CorporateSignupForm";

function CorporateSignupEmbedPage() {
  const containerRef = useRef(null);

  const postResize = useCallback(() => {
    const height = containerRef.current?.scrollHeight || document.body.scrollHeight;
    window.parent?.postMessage(
      {
        type: "resize-corporate-signup-iframe",
        height,
      },
      "*"
    );
  }, []);

  useEffect(() => {
    postResize();

    const observer = new ResizeObserver(postResize);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [postResize]);

  return (
    <div ref={containerRef} style={{ minHeight: 1, background: "#FAFAFA" }}>
      <CorporateSignupForm compact onResize={postResize} />
    </div>
  );
}

export default CorporateSignupEmbedPage;
